import { createRootRouteWithContext, Outlet } from '@tanstack/react-router'
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools'
import { QueryClient } from '@tanstack/react-query'
import type { AuthContext } from '../lib/auth/useAuth'

export interface RouterContext {
  auth: AuthContext
  queryClient: QueryClient
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootComponent,
})

function RootComponent() {
  return (
    <>
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-50 focus:px-3 focus:py-2 focus:bg-background focus:border focus:border-primary focus:rounded focus:text-sm focus:font-medium"
      >
        Skip to main content
      </a>
      <Outlet />
      {import.meta.env?.DEV && <TanStackRouterDevtools position="bottom-right" />}
    </>
  )
}
